import React from 'react';
import MiniHeader from '../components/MiniHeader';
import Team from '../components/Team';
import Destinations from '../components/Destinations';

const Destination = () => {
  return (
    <>
    <MiniHeader title={"Destination"} />
    <Destinations />
    </>
  );
};

export default Destination;
